module.exports = __webpack_public_path__ + "static/media/mainPageIllustartion.9697d440.png";